
import Button from '../../../components/base/Button';
import { Link } from 'react-router-dom';

const services = [
  {
    id: 'peptide-therapy',
    title: 'Peptide Therapy',
    description: 'Cutting-edge cellular regeneration that boosts metabolism, muscle recovery, and immunity with personalized peptide plans.',
    icon: 'ri-dna-line',
    image: 'https://public.readdy.ai/ai/img_res/23c381e54bf203e569f7d733a7b74847.jpg',
    benefits: ['Cellular regeneration', 'Metabolism boost', 'Muscle recovery', 'Immunity enhancement'],
    link: '/services/peptide-therapy'
  },
  {
    id: 'weight-loss',
    title: 'Weight Loss Programs',
    description: 'GLP-1 medications combined with prescription Omega capsules for rapid weight loss, improved mood, and mental clarity.',
    icon: 'ri-scales-3-line',
    image: 'https://readdy.ai/api/search-image?query=Weight%20loss%20transformation%20success%2C%20healthy%20lifestyle%2C%20medical%20weight%20management%2C%20before%20and%20after%20concept%2C%20wellness%20journey%2C%20healthy%20nutrition%2C%20fitness%20and%20wellness%2C%20medical%20supervision%2C%20clean%20modern%20clinic%20setting&width=600&height=400&seq=weightloss&orientation=landscape',
    benefits: ['Rapid weight loss', 'Improved mood', 'Boosted energy', 'Mental clarity'],
    link: '/services/weight-loss'
  },
  {
    id: 'iv-therapy',
    title: 'IV Therapy',
    description: 'Hydration and vitamin drips including L-Carnitine, B-Vitamins, and energy infusions for immune support and anti-aging.',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=IV%20therapy%20treatment%20room%2C%20medical%20drip%20infusion%2C%20vitamin%20therapy%2C%20professional%20healthcare%20setting%2C%20clean%20medical%20environment%2C%20IV%20bag%20and%20equipment%2C%20wellness%20clinic%20interior%2C%20hydration%20therapy%2C%20medical%20professional%20administering%20treatment&width=600&height=400&seq=ivtherapy&orientation=landscape',
    benefits: ['Immune support', 'Detoxification', 'Anti-aging', 'Energy boost'],
    link: '/services/iv-therapy'
  },
  {
    id: 'mental-health',
    title: 'Mental Health Services',
    description: 'Comprehensive mental health treatments including Ketamine therapy, psychedelic-assisted therapy, and holistic approaches.',
    icon: 'ri-brain-line',
    image: 'https://readdy.ai/api/search-image?query=Mental%20health%20therapy%20session%2C%20peaceful%20counseling%20room%2C%20professional%20therapist%20office%2C%20calming%20environment%2C%20mental%20wellness%2C%20therapeutic%20setting%2C%20comfortable%20seating%2C%20natural%20lighting%2C%20serene%20atmosphere%2C%20holistic%20mental%20health%20care&width=600&height=400&seq=mentalhealth&orientation=landscape',
    benefits: ['Ketamine therapy', 'Psychedelic assistance', 'Genetic testing', 'Holistic approach'],
    link: '/services/mental-health'
  },
  {
    id: 'sexual-wellness',
    title: 'Sexual Wellness',
    description: 'Personalized treatments for libido enhancement, fertility support, and sexual performance using cutting-edge therapies.',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=Sexual%20wellness%20medical%20consultation%2C%20intimate%20health%20therapy%2C%20professional%20medical%20setting%2C%20confidential%20healthcare%20environment%2C%20wellness%20clinic%20interior%2C%20medical%20consultation%20room%2C%20holistic%20health%20approach%2C%20clean%20modern%20medical%20facility&width=600&height=400&seq=sexualwellness&orientation=landscape',
    benefits: ['Libido enhancement', 'Fertility support', 'Performance improvement', 'Hormonal balance'],
    link: '/services/sexual-wellness'
  },
  {
    id: 'hair-growth',
    title: 'Hair Growth Treatment',
    description: 'Comprehensive hair restoration using peptides, PRP therapy, and cutting-edge treatments for thicker, stronger hair.',
    icon: 'ri-scissors-cut-line',
    image: 'https://readdy.ai/api/search-image?query=Hair%20growth%20treatment%2C%20scalp%20therapy%2C%20medical%20hair%20restoration%2C%20PRP%20treatment%2C%20professional%20dermatology%20clinic%2C%20hair%20follicle%20treatment%2C%20medical%20hair%20care%2C%20peptide%20therapy%20for%20hair%2C%20clean%20medical%20environment&width=600&height=400&seq=hairgrowth&orientation=landscape',
    benefits: ['Peptide therapy', 'PRP treatment', 'Cellular repair', 'Hair transplant access'],
    link: '/services/hair-growth'
  },
  {
    id: 'longevity',
    title: 'Longevity & Life Extension',
    description: 'Advanced anti-aging protocols and life extension therapies designed to optimize cellular health and enhance vitality.',
    icon: 'ri-time-line',
    image: 'https://readdy.ai/api/search-image?query=Anti-aging%20longevity%20treatment%2C%20cellular%20regeneration%2C%20modern%20wellness%20clinic%2C%20healthy%20aging%2C%20life%20extension%20therapy%2C%20medical%20anti-aging%20equipment%2C%20professional%20healthcare%20setting%2C%20wellness%20and%20vitality%2C%20clean%20medical%20environment&width=600&height=400&seq=longevity&orientation=landscape',
    benefits: ['Cellular anti-aging', 'Life extension', 'Vitality enhancement', 'Coming soon'],
    link: '/services/longevity'
  }
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-20 bg-gradient-to-b from-[#F0F0F0] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-black mb-4">
            Our Advanced <span className="text-[#8A4F8A]">Wellness Services</span>
          </h2>
          <p className="text-xl text-[#B0B0B0] max-w-3xl mx-auto">
            Cutting-edge treatments designed to optimize your health, enhance your vitality, and transform your life from the inside out.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={service.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4 w-12 h-12 bg-[#8A4F8A] rounded-full flex items-center justify-center">
                  <i className={`${service.icon} text-xl text-white`}></i>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-black mb-3">{service.title}</h3>
                <p className="text-[#B0B0B0] mb-4">{service.description}</p>
                
                <ul className="space-y-2 mb-6">
                  {service.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-center text-sm text-black">
                      <i className="ri-check-line text-[#8A4F8A] mr-2"></i>
                      {benefit}
                    </li>
                  ))}
                </ul>
                
                <Link to={service.link}>
                  <Button className="w-full">
                    {service.id === 'longevity' ? 'Coming Soon' : 'Learn More'}
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button size="lg" variant="secondary">
            <i className="ri-calendar-line mr-2"></i>
            Schedule Your Free Consultation
          </Button>
        </div>
      </div>
    </section>
  );
}
